import React from 'react'
import { Skeleton, Typography, message } from 'antd'
import styled from 'styled-components'

import { useCaseViewContext } from '../../context'
import { SectionHeader } from '../SectionHeader'
import { Container } from '../../Styles'

const TELEMEDICINE_CATEGORIES = {
  TESTOSTERONE: {
    name: 'testosterone',
    categoryId: '66154b471d36a7fe42f19d61'
  }
}

// Styled components
const PDMPLink = styled.button`
  border: none;
  background: none;
  padding: 0;
  color: #1890ff;
  cursor: pointer;
  text-decoration: underline;
  
  &:hover {
    color: #40a9ff;
  }
`

export const PDMP = () => {
  const { caseDetails, apiClasses } = useCaseViewContext()

  const categoryId = caseDetails?.categoryId
  const categoryName = caseDetails?.categoryName || caseDetails?.category?.name || caseDetails?.teleMedicineCategory?.name
  const isTestosteroneCase = categoryId === TELEMEDICINE_CATEGORIES.TESTOSTERONE.categoryId || 
                            categoryName?.toLowerCase() === TELEMEDICINE_CATEGORIES.TESTOSTERONE.name

  if (!isTestosteroneCase) return null

  const handlePDMPClick = async () => {
    if (!caseDetails?.pdmpResource) {
      message.error('No PDMP resource available')
      return
    }

    try {
      window.open(caseDetails.pdmpResource, '_blank')

      if (apiClasses?.CasesApi?.registerPDMPView) {
        await apiClasses.CasesApi.registerPDMPView(
          caseDetails._id || caseDetails.caseId, 
          caseDetails.pdmpResource
        )
        message.success('PDMP view registered successfully')
      }
    } catch (error) {
      console.error('Error registering PDMP view:', error)
      let errorMessage = 'Error registering PDMP view'
      if (error.response?.data?.message) {
        errorMessage += `: ${error.response.data.message}`
      }
      message.error(errorMessage)
    }
  }

  return (
    <Container>
      <Skeleton loading={!caseDetails} paragraph={{ rows: 1 }}>
        <SectionHeader title="PDMP Resource" />
      </Skeleton>
      <div>
        {caseDetails?.pdmpResource ? (
          <PDMPLink onClick={handlePDMPClick}>
            {caseDetails.pdmpResource}
          </PDMPLink>
        ) : (
          <Typography.Text type="secondary">
            Missing PDMP Config for state
          </Typography.Text>
        )}
      </div>
    </Container>
  )
}